import React, { Fragment, PureComponent } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, Col, Button, ButtonToolbar, Table } from "reactstrap";

import "./styles.css";
import axios from "axios";
import _ from "lodash";



class DRSCLDReportDetail extends PureComponent {
  constructor(props) {
    /*var today = new Date(),
            date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();*/

    var tempDate = new Date();
    var date =
      tempDate.getFullYear() +
      "-" +
      (tempDate.getMonth() + 1) +
      "-" +
      tempDate.getDate() +
      " " +
      tempDate.getHours() +
      ":" +
      tempDate.getMinutes() +
      ":" +
      tempDate.getSeconds();
    const currDate = date;
    super(props);
    this.onLogin = this.onLogin.bind(this);
    this.prinData = this.prinData.bind(this);
    this.state = {
      showPassword: false,
      showPrintData1: [],
      showCLDData: [],
      date: currDate,
      total_value:""
    };

    this.showPassword = this.showPassword.bind(this);
  }

  showPassword(e) {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  }

  componentDidMount() {
    var printDetail_data = localStorage.getItem("DRSData");
    var printDetails = JSON.parse(printDetail_data);
     var cld_data = localStorage.getItem("CLDData");
    var CLDDataDetails = JSON.parse(cld_data);
    /* console.log(printDetail_data);*/
    var sub_total = 0;
    var total_val;
    for(var i= 0; i< printDetails.length; i++){
      total_val = sub_total + printDetails[i].box_id_count;
      sub_total = total_val
    }
    this.setState({
      showPrintData1: printDetails,
      showCLDData: CLDDataDetails,
      total_value: total_val
    })



    setTimeout(this.prinData, 1100);

  }

  prinData() {
    /* for (var i = 0; i < this.state.printDetails.length; i++) {*/
    window.print();

    /*}*/
  }

  onLogin() {
    axios
      .post(
        "http://3.215.84.36:8088/auth/oauth2/login",

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "",
          },
        }
      )
      .then((response) => {
        console.log(response.data.login);
        if (response.data.login === false) {
          window.location.href = response.data.url;
        }
      })
      .catch(function (error) {});
  }

  render() {
    const { handleSubmit } = this.props;
    //   const { showPassword } = this.state;
    
   
    
    return (
      <div className="print_table">
        <Table style={{borderWidth: 0, marginBottom: 0, width: '90%', margin: 'auto', marginTop: 30, textAlign: 'center'}}
        >
            <thead
              style={{ background: "#ccc", textAlign: 'center' }}
            >
              <tr style={{ marginTop: 20, background: "#fff", textAlign: 'center' }}>
        
                <th style={{textAlign: 'center', borderWidth: 0}} colspan="12"><h4 style={{margin: 0, fontWeight: 'bold'}}>DRS Sheet</h4></th>
               </tr>
              
            </thead>
        </Table> 

        <div style={{ width: "90%", margin: 'auto' }}>
          <table style={{width: '100%', padding: 15, borderWidth: 0}}
                    responsive
                    
                  >
                      <tr>
                        <td style={{borderWidth: 0}} colspan = "6"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              TP van:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1[0].tp_van} </span>}{" "}
                          </h5>
                        </td>

                         <td style={{borderWidth: 0}} colspan = "7"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Trip  date:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1[0].trip_date} </span>}{" "}
                          </h5>
                        </td>
                        <td style={{borderWidth: 0, textAlign: 'left'}} colspan = "5"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Bill count:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1.length} </span>}{" "}
                          </h5>
                        </td>


                        <td style={{borderWidth: 0, textAlign: 'left'}} colspan = "4"> 
                          <h5>
                            {" "}
                            <span style={{ fontWeight: "bold" }}>
                              {" "}
                              Bill value:{" "}
                            </span>{" "}
                            {this.state.showPrintData1.length> 0 &&
                            <span> {this.state.showPrintData1[0].bill_value} </span>}{" "}
                          </h5>
                        </td>
                      </tr>
                    </table>

                     <table style={{width: '100%', padding: 15, borderWidth: 0, marginTop: 20}}
                    responsive
                    
                  >
                    <thead
                      className="thead_align"
                      style={{ background: "#ccc" }}
                    >
                   <tr className="border-thead border_head border_thead drs_thead" style={{ marginTop: 20 }}>
                         <th style={{ marginTop: 20 }}>Sr No.</th> 
                        <th style={{ marginTop: 20 }}>Bill No </th>
                        <th style={{ marginTop: 20 }}> PARTY </th>
                        <th style={{ marginTop: 20 }}> BOX ID Count </th>
                        
                        

                        <th style={{ marginTop: 20 }}> Box Ids </th>

                        </tr>

                    </thead>

                     <tbody>
                      {this.state.showPrintData1.length > 0 &&
                        this.state.showPrintData1.map((item, index) => (
                          <tr className="border-thead border_thead drs_row">
                            <td>{index+1}</td>
                            <td>{item.bill_no}</td>
                            <td>{item.party_name}</td>
                            <td>{item.box_id_count}</td>
                            <td>{item.box_ids}</td>
                          </tr>
                        ))}
                </tbody>
               {/* <tfoot>
                <td colspan="3"></td>
                <td>Total Box Id Count: {this.state.total_value}</td>
                {this.state.showPrintData1.length>0 &&
                  <td>Total: {this.state.showPrintData1[0].bill_value}</td>
                }
                {this.state.showPrintData1.length == 0 &&
                  <td></td>
                }
                

                </tfoot>
*/}
                    </table>
        </div> 

         <Table style={{borderWidth: 0, marginBottom: 0, width: '90%', margin: 'auto', marginTop: 30, textAlign: 'center'}}
        >
            <thead
              style={{ background: "#ccc", textAlign: 'center' }}
            >
              <tr style={{ marginTop: 20, background: "#fff", textAlign: 'center' }}>
        
                <th style={{textAlign: 'center', borderWidth: 0}} colspan="12"><h4 style={{margin: 0, fontWeight: 'bold'}}>CLD Sheet</h4></th>
               </tr>
              
            </thead>
        </Table> 

         <div style={{ width: "90%", margin: 'auto' }}>

                     <table style={{width: '100%', padding: 15, borderWidth: 0, marginTop: 20}}
                    responsive
                    
                  >
                    <thead
                      className="thead_align"
                      style={{ background: "#ccc" }}
                    >
                   <tr className="border-thead border_head border_thead drs_thead" style={{ marginTop: 20 }}>
                         <th style={{ marginTop: 20 }}>Sr No.</th> 
                        <th style={{ marginTop: 20 }}>PTL  Id </th>
                        <th style={{ marginTop: 20 }}> SKU7 </th>
                        <th style={{ marginTop: 20 }}> Prod Name </th>
                        
                        

                        <th style={{ marginTop: 20 }}> UPC </th>
                        <th style={{ marginTop: 20 }}> MRP </th>

                        <th style={{ marginTop: 20 }}> Free Product </th>
                        <th style={{ marginTop: 20 }}> Free Loose </th>
                        <th style={{ marginTop: 20 }}> CLD To be picked </th>




                        </tr>

                    </thead>

                     <tbody>
                      {this.state.showCLDData.length > 0 &&
                        this.state.showCLDData.map((item, index) => (
                          <tr className="border-thead border_thead drs_row">
                            <td>{item.s_no}</td>
                            <td>{item.trip_id}</td>
                            <td>{item.sku7_code}</td>
                            <td>{item.prod_name}</td>
                            <td>{item.upc}</td>
                            <td>{item.mrp}</td>
                            <td>{item.free_cld}</td>
                            <td>{item.free_loose}</td>
                            <td>{item.to_be_picked_icld_qty}</td>


                          </tr>
                        ))}
                </tbody>
               

                    </table>
        </div> 

       
       
      </div>
    );
  }
}

export default DRSCLDReportDetail;
